<template>
  <div class="locale-changer">
    <a>{{ t("select_language") }}:</a>
    <br />
    <select v-model="$i18n.locale" class="b-nav-item">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.short">
        <span v-html="lang.flag"></span> {{ lang.name }}
      </option>
    </select>
  </div>
</template>

<i18n>
en:
  select_language: "Sprache auswählen"
de:
  select_language: "Select language"
</i18n>


<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const langs = ref(
  [
    {
      name: "Deutsch",
      short: "de",
      flag: "&#x1F1E9;&#x1F1EA;",
    },
    {
      name: "English",
      short: "en",
      flag: "&#x1F1EC;&#x1F1E7;",
    },
  ],
)

watch(locale, (lang) => {
  document.querySelector("html").setAttribute("lang", lang);
})
</script>

<style scoped>
a {
  margin-right: 10px;
}

label {
  margin-top: 24px;
  font-size: medium;
}

select {
  font-size: large;
}
</style>
